<template>
    <div class="root_info_user">
        <div class="container ner_detail_vd">
            <div class="wp_slider_video_detail">
                <div class="video_show_detail">
                    <video width="100%" height="695" id="video1" autoplay controls class="videoDetail_watch" controlsList="nodownload" v-if="listVideo.filename">
                        <source :src="listVideo.filename" type="video/mp4">
                    </video>
                    <div class="wp_info_video">
                        <div class="flex_video">
                            <div class="img_idol_video">
                                <img :src="listVideo.thumbnail" alt="" style="object-fit: cover;">
                            </div>
                            <div class="nametitle_idol_video">
                                <p class="titlevideo">{{ listVideo.title }}</p>
                            </div>
                        </div>
                        <div class="content_info_video">
                            {{ listVideo.description }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="root_video_live" v-if="listOtherVideo.length > 0">
            <h2 class="title_category title_category0"><font-awesome-icon icon="fa-solid fa-video" /> <span>Video</span></h2>
            <div class="row">
                <div class="col-md-2 col-sm-2 col-xs-3 wp-item-live" v-for="(item, index) in datas" :key="index">
                    <div class="item_live">
                        <router-link v-bind:to="{ name: 'VideoPlay_nm', params: { id: item.id } }">
                            <div class="img_live img_live_video">
                                <img :src="item.thumbnail" alt="">
                            </div>
                            <div class="text_item_live text_item_live1">
                                <div class="img_live_small">
                                    <img :src="item.thumbnail" alt="">
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <div class="text_video_preview">
                        <router-link v-bind:to="{ name: 'VideoPlay_nm', params: { id: item.id } }">
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.description }}</p>
                        </router-link>
                    </div>
                </div>
            </div>
            <paginate @update:modelValue="clickCallback" :totalCount="totalCount" :limit="perPage" v-model="page"></paginate>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoPlay_nm',
    data () {
        return {
            id: parseInt(this.$route.params.id),
            listVideo: [],
            page: 1,
            perPage: 15,
            totalCount: 0,
            datas: [],
            listOtherVideo: [],
            listLinks: []
        }
    },
    components: {
        
    },
    created () {
        this.getVideoView()
        this.getVideoList()
    },
    methods: {
        getVideoView () {
            this.axios.get(this.api_linkVideoDetail + '/' + this.id, 
                {
                    headers: {
                        'x-api-key': 'your-secret-api-key-123'
                    }
                }
            ).then((response) => {
                this.listVideo = response.data
            })
        },
        getVideoList () {
            this.axios.get(this.api_linkAllVideo,
                {
                    headers: {
                        'x-api-key': 'your-secret-api-key-123'
                    }
                }
            ).then((response) => {
                this.listOtherVideo = response.data
                this.totalCount = this.listOtherVideo.length
                this.paginatedData()
            })
        },
        paginatedData () {
            this.datas = this.listOtherVideo.slice((this.page - 1) * this.perPage, this.page * this.perPage)
        },
        clickCallback (pageNum) {
            this.page = pageNum;
            this.paginatedData();
        },
    }
}
</script>
<style>
</style>
